import { render, staticRenderFns } from "./ReverseDns.vue?vue&type=template&id=fe56bb2c&"
import script from "./ReverseDns.vue?vue&type=script&lang=js&"
export * from "./ReverseDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReverseDns.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports